import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { SegmentLOBModel } from "../../models/SegmentLOBModel";
import SegmentLOBService from "../../services/SegmentLOBService";
import SegmentLOBSlice from "../slices/SegmentLOBSlice";
import { RootState } from "../store";

export const SegmentLOBActions = SegmentLOBSlice.actions;
export const fetchSegmentLOBs = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(SegmentLOBActions.setIsSegmentLOBsFetching(true));
    const response: SegmentLOBModel[] =
      await SegmentLOBService.getAllSegmentLOBs();
    dispatch(SegmentLOBActions.setSegmentLOBs(response));
    dispatch(SegmentLOBActions.setIsSegmentLOBsFetching(false));
  };
};
export const fetchSegmentsByBU = (
  BUID: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: SegmentLOBModel[] = await SegmentLOBService.getSegmentsByBU(
      BUID
    );
    dispatch(SegmentLOBActions.setSegmentsByBU(response));
  };
};
export const fetchParticularSegmentLOB = (
  SegmentLOB_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: SegmentLOBModel =
      await SegmentLOBService.getParticularSegmentLOB(SegmentLOB_id);
    dispatch(SegmentLOBActions.setParticularSegmentLOB(response));
  };
};
